// Full FR/EN copy for the SZN TRIP public site. FR is the reference.
export const translations = {
  fr: {
    lang: "FR",
    header: {
      nav: [
        ["Le concept", "#concept"],
        ["La commu", "#communaute"],
        ["Punta Cana", "#punta-cana"],
        ["Inclus", "#inclus"],
        ["FAQ", "#faq"],
      ],
      ctaWaitlist: "Je veux en être",
      ctaBooking: "Réserver",
    },
    hero: {
      badge: "Le 1ᵉʳ IRL de la commu saisonniers",
      lines: ["ON SE", "RETROUVE À", "PUNTA CANA"],
      accent: "EN 2027.",
      subtitle:
        "Le premier rassemblement entre saisonniers français. Un resort les pieds dans le sable pour la communauté SZN.",
      cta: "Je veux en être",
      secondary: "C'est quoi le délire ?",
      location: "République Dominicaine · Novembre 2027 · via Nouvelles Destinations (Atout France)",
      capBig: "la commu, IRL",
      capSmall: "nov. 2027",
    },
    marquee: ["Saisonniers only", "Punta Cana 2027", "76 places", "La commu SZN", "IRL"],
    s1: {
      kicker: "la vie de saisonnier",
      title: "Tu connais cette vie.",
      body: [
        "Contrats qui s'enchaînent, horaires à l'envers, des journées qui démarrent quand les autres sont en vacances. Sur la route, tu croises d'autres saisonniers qui vivent exactement ce rythme — mais entre deux services, il n'y a jamais le temps de vraiment se retrouver.",
        "Cette fois, si. Amène ta bande si tu veux, ou viens seul — tu ne resteras pas longtemps sans connaître personne.",
      ],
      punch: "Et si, pour une fois, c'était ton tour ?",
      cap1: "saison #7",
      cap2: "la bande",
    },
    s2: {
      kicker: "le concept",
      titlePre: "PUNTA CANA POUR LE CADRE, ",
      titleAccent: "TOI",
      titlePost: " POUR LE PLAISIR.",
      body: [
        "Punta Cana, c'est le cadre qu'on a choisi pour toi : soleil garanti pile quand la France entre dans l'hiver, resort tout compris, mer à 26°C. C'est l'endroit parfait pour se laisser aller, rencontrer, se relaxer au bord d'une eau turquoise.",
        "Mais ce qui fait vraiment ce voyage, ce sont les gens que tu y retrouves, tes amis et des saisonniers de toute la France, qui vivent exactement ton rythme. Le décor est magnifique. La vraie raison de venir : toi, pour te ressourcer. Eux, pour profiter ensemble.",
      ],
      cards: [
        ["26°", "l'eau des Caraïbes, pile quand la France grelotte"],
        ["Tout compris", "repas, boissons, soirées"],
        ["Sable blanc", "et mer turquoise à perte de vue"],
        ["1ère", "édition"],
      ],
      caption: "la vraie rencontre",
    },
    s3: {
      kicker: "la communauté szn",
      titlePre: "SZN TRIP, c'est",
      titleAccent: "SEAZONER",
      titlePost: "en vrai.",
      body: "Sur l'app SEAZONER, chaque station vit un peu dans son coin : tu connais ta team, ton rythme — rarement ce qui se passe trois vallées plus loin, ou à l'autre bout de la France. SZN TRIP, c'est la première fois que la commu sort de son coin, toutes stations confondues.",
      bullets: [
        "Des gens qui vivent exactement comme toi",
        "Toutes les stations, tous les postes, réunis pour la première fois",
        "Des moments rien que pour la commu, glissés dans le séjour",
        "Tout ce qui se passe à Punta Cana, reste à Punta Cana.",
      ],
      cap1: "#SZNfam",
      cap2: "IRL > online",
    },
    punta: {
      kicker: "le décor",
      title: "PUNTA CANA",
      body: "Eau turquoise, cocotiers à l'infini et 28°C en novembre. Le genre d'endroit qui rend les souvenirs un peu trop beaux pour être vrais. Spoiler : ils le seront.",
      chips: ["28°C en moyenne", "Plage privée", "Resort all-inclusive"],
    },
    hotel: {
      kicker: "le camp de base",
      titlePre: "Un resort",
      titleAccent: "rien que",
      titlePost: "pour nous.",
      body: "Chambres partagées entre saisonniers, bar de plage, piscine, buffet à volonté. Un QG les pieds dans le sable où la commu prend ses quartiers pour une semaine.",
      cards: [
        ["All inclusive", "Repas & boissons compris"],
        ["Accès plage", "Directement depuis l'hôtel"],
        ["Wi-Fi partout", "Pour spammer la commu"],
        ["Chambres commu", "Partagées entre saisonniers"],
      ],
      caption: "notre QG",
    },
    excursions: {
      kicker: "le programme",
      title: "Des souvenirs, pas des selfies",
      label: "Excursion",
      items: [
        ["Isla Saona", "Catamaran, piscine naturelle, journée pieds dans l'eau turquoise.", "Sailboat"],
        ["Buggy & lagon", "Poussière, adrénaline et cenote caché en fin de parcours.", "Car"],
        ["Beach party SZN", "La soirée signature de la commu, sur le sable, jusqu'au bout de la nuit.", "Music"],
        ["Snorkeling récif", "Masque, tuba et bancs de poissons à deux battements de palmes.", "Waves"],
      ],
    },
    soloTeam: {
      kicker: "peu importe comment tu viens",
      titlePre: "Seul ou en",
      titleAccent: "team.",
      soloTitle: "Tu viens solo",
      soloBody:
        "Tu n'as pas besoin de connaître quelqu'un pour venir. Chambres partagées, excursions et activités en journée ou en soirée : la commu se charge de faire que tu ne restes jamais seul. Tu repars avec des nouveaux potes, pas juste des souvenirs.",
      teamTitle: "Tu viens en team",
      teamBody:
        "Ta bande veut suivre — collègues de saison, potes, ou les deux ? Dis-nous combien vous êtes dès l'inscription : on garde vos places côte à côte.",
    },
    included: {
      kicker: "le pack",
      title: "Ce qui est inclus",
      passLabel: "SZN TRIP · PASS COMMU",
      passTag: "tout compris",
      items: [
        ["Vols A/R", "Paris → Punta Cana, groupés avec la commu."],
        ["7 nuits en resort", "Chambres partagées entre saisonniers, pieds dans le sable."],
        ["All inclusive", "Repas, boissons, bar de plage — zéro calcul sur place."],
        ["Transferts", "Aéroport ↔ hôtel gérés de bout en bout."],
        ["Le programme SZN", "Soirées, jeux, rencontres — l'ADN de la commu."],
        ["1 excursion offerte", "Une sortie signature incluse dans le pack."],
      ],
    },
    testimonials: {
      kicker: "ils l'ont vécu",
      title: "Filmé au téléphone. Pas retouché.",
      items: [
        ["\"On était 40, on s'est quittés en famille.\"", "0:38 · Maya, Val Tho"],
        ["\"Le meilleur inter-saison de ma vie.\"", "0:52 · Tom, La Rochelle"],
        ["\"Parti seul, revenu avec une bande.\"", "0:44 · Inès, Chamonix"],
      ],
    },
    price: {
      dates: "Novembre 2027 · 7 nuits",
      fromLabel: "à partir de (indicatif)",
      exactLabel: "tarif tout compris",
      noteFallback: "Tarif provisoire — confirmé à l'ouverture des réservations.",
      bookingSub: "Paiement sécurisé chez notre partenaire Nouvelles Destinations (Atout France).",
      ctaWaitlist: "Je veux en être",
      ctaBooking: "Réserver ma place",
      disclaimerWaitlist: "Aucun paiement · aucun engagement · moins d'1 min",
      disclaimerBooking: "Redirection vers l'agence partenaire",
      gaugeTitle: "Il reste des places ?",
      gaugeSub: "76 places contractuelles, pas une de plus. La jauge est mise à jour en direct.",
      gaugeNote:
        "Complet ? Rejoins la liste d'attente : si la demande dépasse les 76 places, on regarde avec l'agence pour élargir ce même séjour. Tu seras prévenu·e en priorité.",
      dateCard: "Départ · Novembre 2027",
      dateCardSub: "Dates exactes communiquées à la commu en avant-première.",
      gaugeLabel: "La jauge",
      seats: "places",
      justOpened: "Les inscriptions viennent d'ouvrir.",
      raised: "{n} saisonnier·ère·s ont déjà levé la main.",
    },
    faq: {
      kicker: "on t'explique",
      title: "FAQ",
      items: [
        [
          "C'est une agence de voyage ?",
          "Non. SZN TRIP, c'est le premier événement physique de la communauté SZN. Punta Cana est juste le décor. Le voyage est commercialisé par l'agence Nouvelles Destinations (immatriculée Atout France) : le paiement se fera chez eux, jamais sur ce site.",
        ],
        [
          "C'est pour qui ?",
          "Tu es saisonnier ou saisonnière en France, tu as envie de rencontrer d'autres personnes qui vivent ce rythme — peu importe ta station, ton poste, ton âge. C'est pour toi.",
        ],
        [
          "Je pars seul, c'est chaud ?",
          "C'est même la meilleure façon de venir. La moitié des inscrits partent solo. Tout est pensé pour que personne ne reste sur le côté.",
        ],
        [
          "Combien ça coûte ?",
          "Le tarif définitif sera confirmé une fois les coûts réels connus. Pour l'instant on affiche une fourchette indicative, clairement provisoire. La liste prioritaire ne t'engage à rien et n'implique aucun paiement.",
        ],
        [
          "Que se passe-t-il après mon inscription ?",
          "Tu rejoins la liste prioritaire. Tu es prévenu·e en avant-première dès l'ouverture des réservations et tu gardes ta place sur les 76 disponibles.",
        ],
        [
          "Mes données sont protégées ?",
          "Oui. On ne collecte que l'essentiel, avec ton consentement, uniquement pour te tenir informé·e de SZN TRIP. Rien n'est revendu.",
        ],
      ],
    },
    finalCta: {
      signature: "UNE SEULE COMMU.",
      body: "La liste prioritaire, c'est ta longueur d'avance. Aucun paiement, juste la garantie d'être prévenu·e en premier.",
      ctaWaitlist: "Je veux en être",
      ctaBooking: "Réserver ma place",
    },
    footer: {
      tagline: "Le premier événement physique de la communauté SZN (app SEAZONER). Punta Cana, novembre 2027.",
      colTrip: "Le voyage",
      links: [
        ["Le concept", "#concept"],
        ["Punta Cana", "#punta-cana"],
        ["Ce qui est inclus", "#inclus"],
        ["FAQ", "#faq"],
      ],
      colLegal: "Vendeur & mentions",
      legal: {
        soldBy: "Voyage commercialisé par :",
        company: "Nouvelles Destinations",
        atout: "Immatriculation Atout France :",
        guarantee: "Garant financier :",
        insurance: "Assurance RC Pro :",
        toComplete: "n° à compléter",
        toCompleteShort: "à compléter",
      },
      mentions: "Mentions légales",
      privacy: "Politique de confidentialité (RGPD)",
      rights: "Communauté SZN / SEAZONER. Ce site est une vitrine, pas un site de vente.",
    },
    modal: {
      title: "Je veux",
      titleAccent: "en être",
      subtitle: "Liste prioritaire · aucun paiement · moins d'une minute.",
      prenom: "Prénom",
      age: "Âge",
      agePlaceholder: "—",
      email: "Email",
      tel: "Téléphone",
      region: "Région",
      station: "Station / activité saisonnière",
      stationPlaceholder: "Val Thorens, camping du Cap, festival…",
      comingLabel: "Tu viens…",
      solo: "Solo",
      team: "En team",
      teamSize: "Vous êtes combien ? (estimation)",
      consentPre: "J'accepte d'être recontacté·e au sujet de SZN TRIP et j'ai lu les ",
      consentLink: "mentions légales & politique de confidentialité",
      submit: "Rejoindre la liste prioritaire",
      successTitle: "Bienvenue dans la commu",
      successBody:
        "Tu es sur la liste prioritaire. On te prévient en avant-première dès l'ouverture des réservations.",
      close: "Fermer",
      toastSuccess: "Tu es sur la liste prioritaire ! 🌴",
      errConsent: "Le consentement RGPD est obligatoire.",
      errAge: "Choisis ta tranche d'âge.",
      ageSuffix: "ans",
    },
    legalPage: {
      backHome: "Retour à l'accueil",
      draft: "en cours de rédaction",
      mentionsTitle: "Mentions légales",
      privacyTitle: "Politique de confidentialité",
      draftBody:
        "Cette page est en cours de rédaction. Le contenu définitif sera publié prochainement, une fois validé avec notre partenaire Nouvelles Destinations (immatriculée Atout France).",
      contact: "Pour toute question, contacte-nous à laurent@seazoner.fr.",
    },
  },

  en: {
    lang: "EN",
    header: {
      nav: [
        ["The concept", "#concept"],
        ["The community", "#communaute"],
        ["Punta Cana", "#punta-cana"],
        ["Included", "#inclus"],
        ["FAQ", "#faq"],
      ],
      ctaWaitlist: "I want in",
      ctaBooking: "Book now",
    },
    hero: {
      badge: "The 1st IRL meetup of the seasonal-worker community",
      lines: ["SEE YOU", "IN PUNTA", "CANA"],
      accent: "IN 2027.",
      subtitle:
        "The first-ever gathering of French seasonal workers. A resort with your feet in the sand, for the SZN community.",
      cta: "I want in",
      secondary: "What's the deal?",
      location: "Dominican Republic · November 2027 · via Nouvelles Destinations (Atout France)",
      capBig: "the community, IRL",
      capSmall: "nov. 2027",
    },
    marquee: ["Seasonal workers only", "Punta Cana 2027", "76 spots", "The SZN community", "IRL"],
    s1: {
      kicker: "the seasonal life",
      title: "You know this life.",
      body: [
        "Contract after contract, upside-down hours, days that start when everyone else is on holiday. On the road, you cross paths with other seasonal workers living the exact same rhythm — but between two shifts, there's never time to truly connect.",
        "This time, there is. Bring your crew if you want, or come solo — you won't stay a stranger for long.",
      ],
      punch: "And what if, for once, it was your turn?",
      cap1: "season #7",
      cap2: "the crew",
    },
    s2: {
      kicker: "the concept",
      titlePre: "PUNTA CANA FOR THE SETTING, ",
      titleAccent: "YOU",
      titlePost: " FOR THE GOOD TIMES.",
      body: [
        "Punta Cana is the setting we picked for you: guaranteed sun right when France slips into winter, an all-inclusive resort, a 26°C sea. The perfect place to let go, meet people and unwind beside turquoise water.",
        "But what really makes this trip is the people you meet there — your friends and seasonal workers from all over France, living the exact same rhythm as you. The scenery is stunning. The real reason to come: you, to recharge. Them, to enjoy it together.",
      ],
      cards: [
        ["26°", "Caribbean water, right when France is shivering"],
        ["All inclusive", "meals, drinks, parties"],
        ["White sand", "and turquoise sea as far as the eye can see"],
        ["1st", "edition"],
      ],
      caption: "the real meetup",
    },
    s3: {
      kicker: "the szn community",
      titlePre: "SZN TRIP is",
      titleAccent: "SEAZONER",
      titlePost: "for real.",
      body: "On the SEAZONER app, every resort lives a little in its own corner: you know your team, your rhythm — rarely what's happening three valleys over, or on the other side of the country. SZN TRIP is the first time the community steps out of its corner, all resorts combined.",
      bullets: [
        "People who live exactly like you",
        "Every resort, every role, together for the first time",
        "Moments just for the community, woven into the trip",
        "Whatever happens in Punta Cana, stays in Punta Cana.",
      ],
      cap1: "#SZNfam",
      cap2: "IRL > online",
    },
    punta: {
      kicker: "the setting",
      title: "PUNTA CANA",
      body: "Turquoise water, endless palm trees and 28°C in November. The kind of place that makes memories almost too good to be true. Spoiler: they will be.",
      chips: ["28°C on average", "Private beach", "All-inclusive resort"],
    },
    hotel: {
      kicker: "base camp",
      titlePre: "A resort",
      titleAccent: "just for",
      titlePost: "us.",
      body: "Rooms shared between seasonal workers, a beach bar, a pool, an all-you-can-eat buffet. A base with your feet in the sand where the community settles in for a week.",
      cards: [
        ["All inclusive", "Meals & drinks included"],
        ["Beach access", "Straight from the hotel"],
        ["Wi-Fi everywhere", "To spam the community"],
        ["Community rooms", "Shared between seasonal workers"],
      ],
      caption: "our base",
    },
    excursions: {
      kicker: "the programme",
      title: "Memories, not selfies",
      label: "Excursion",
      items: [
        ["Isla Saona", "Catamaran, natural pool, a day with your feet in turquoise water.", "Sailboat"],
        ["Buggy & lagoon", "Dust, adrenaline and a hidden cenote at the end of the ride.", "Car"],
        ["SZN beach party", "The community's signature night, on the sand, until the early hours.", "Music"],
        ["Reef snorkeling", "Mask, snorkel and schools of fish two fin-kicks away.", "Waves"],
      ],
    },
    soloTeam: {
      kicker: "however you come",
      titlePre: "Solo or with your",
      titleAccent: "crew.",
      soloTitle: "You come solo",
      soloBody:
        "You don't need to know anyone to come. Shared rooms, day and night excursions and activities: the community makes sure you're never left on your own. You leave with new friends, not just memories.",
      teamTitle: "You come with your crew",
      teamBody:
        "Your crew wants to follow — season colleagues, mates, or both? Tell us how many you are when you sign up: we keep your spots side by side.",
    },
    included: {
      kicker: "the pack",
      title: "What's included",
      passLabel: "SZN TRIP · COMMUNITY PASS",
      passTag: "all inclusive",
      items: [
        ["Return flights", "Paris → Punta Cana, grouped with the community."],
        ["7 nights at the resort", "Rooms shared between seasonal workers, feet in the sand."],
        ["All inclusive", "Meals, drinks, beach bar — zero math on site."],
        ["Transfers", "Airport ↔ hotel handled end to end."],
        ["The SZN programme", "Parties, games, meetups — the community's DNA."],
        ["1 excursion included", "A signature outing included in the pack."],
      ],
    },
    testimonials: {
      kicker: "they lived it",
      title: "Filmed on a phone. Not retouched.",
      items: [
        ["\"We were 40, we left as a family.\"", "0:38 · Maya, Val Tho"],
        ["\"The best off-season of my life.\"", "0:52 · Tom, La Rochelle"],
        ["\"Came alone, left with a crew.\"", "0:44 · Inès, Chamonix"],
      ],
    },
    price: {
      dates: "November 2027 · 7 nights",
      fromLabel: "from (indicative)",
      exactLabel: "all-inclusive price",
      noteFallback: "Provisional price — confirmed when bookings open.",
      bookingSub: "Secure payment with our partner Nouvelles Destinations (Atout France).",
      ctaWaitlist: "I want in",
      ctaBooking: "Book my spot",
      disclaimerWaitlist: "No payment · no commitment · under 1 min",
      disclaimerBooking: "Redirect to the partner agency",
      gaugeTitle: "Any spots left?",
      gaugeSub: "76 contractual spots, not one more. The gauge updates live.",
      gaugeNote:
        "Full? Join the waiting list: if demand exceeds the 76 spots, we'll look with the agency at expanding this same trip. You'll be notified first.",
      dateCard: "Departure · November 2027",
      dateCardSub: "Exact dates shared with the community first.",
      gaugeLabel: "The gauge",
      seats: "spots",
      justOpened: "Sign-ups just opened.",
      raised: "{n} seasonal workers have already raised their hand.",
    },
    faq: {
      kicker: "let us explain",
      title: "FAQ",
      items: [
        [
          "Is this a travel agency?",
          "No. SZN TRIP is the first physical event of the SZN community. Punta Cana is just the setting. The trip is sold by the agency Nouvelles Destinations (registered with Atout France): payment happens with them, never on this site.",
        ],
        [
          "Who is it for?",
          "You're a seasonal worker in France and you want to meet other people living this rhythm — whatever your resort, your role, your age. It's for you.",
        ],
        [
          "I'm coming alone, is that awkward?",
          "It's actually the best way to come. Half of those signed up come solo. Everything is designed so no one is left on the side.",
        ],
        [
          "How much does it cost?",
          "The final price will be confirmed once real costs are known. For now we show an indicative range, clearly provisional. The priority list commits you to nothing and involves no payment.",
        ],
        [
          "What happens after I sign up?",
          "You join the priority list. You're notified first when bookings open and you keep your spot among the 76 available.",
        ],
        [
          "Is my data protected?",
          "Yes. We only collect the essentials, with your consent, purely to keep you informed about SZN TRIP. Nothing is resold.",
        ],
      ],
    },
    finalCta: {
      signature: "ONE COMMUNITY.",
      body: "The priority list is your head start. No payment, just the guarantee of being notified first.",
      ctaWaitlist: "I want in",
      ctaBooking: "Book my spot",
    },
    footer: {
      tagline: "The first physical event of the SZN community (SEAZONER app). Punta Cana, November 2027.",
      colTrip: "The trip",
      links: [
        ["The concept", "#concept"],
        ["Punta Cana", "#punta-cana"],
        ["What's included", "#inclus"],
        ["FAQ", "#faq"],
      ],
      colLegal: "Seller & legal",
      legal: {
        soldBy: "Trip sold by:",
        company: "Nouvelles Destinations",
        atout: "Atout France registration:",
        guarantee: "Financial guarantor:",
        insurance: "Professional liability insurance:",
        toComplete: "no. to be completed",
        toCompleteShort: "to be completed",
      },
      mentions: "Legal notice",
      privacy: "Privacy policy (GDPR)",
      rights: "SZN / SEAZONER community. This site is a showcase, not a sales platform.",
    },
    modal: {
      title: "I want",
      titleAccent: "in",
      subtitle: "Priority list · no payment · under a minute.",
      prenom: "First name",
      age: "Age",
      agePlaceholder: "—",
      email: "Email",
      tel: "Phone",
      region: "Region",
      station: "Resort / seasonal activity",
      stationPlaceholder: "Val Thorens, seaside campsite, festival…",
      comingLabel: "You're coming…",
      solo: "Solo",
      team: "With a crew",
      teamSize: "How many are you? (estimate)",
      consentPre: "I agree to be contacted about SZN TRIP and I've read the ",
      consentLink: "legal notice & privacy policy",
      submit: "Join the priority list",
      successTitle: "Welcome to the community",
      successBody:
        "You're on the priority list. We'll notify you first as soon as bookings open.",
      close: "Close",
      toastSuccess: "You're on the priority list! 🌴",
      errConsent: "GDPR consent is required.",
      errAge: "Choose your age range.",
      ageSuffix: "yrs",
    },
    legalPage: {
      backHome: "Back to home",
      draft: "being written",
      mentionsTitle: "Legal notice",
      privacyTitle: "Privacy policy",
      draftBody:
        "This page is being written. The final content will be published soon, once validated with our partner Nouvelles Destinations (registered with Atout France).",
      contact: "For any questions, reach us at laurent@seazoner.fr.",
    },
  },
};

export const AGES = ["18-24", "25-29", "30-35", "36+"];
